import { render } from "./BlocoProdução.vue?vue&type=template&id=5ec82e1a"
import script from "./BlocoProdução.vue?vue&type=script&lang=js"
export * from "./BlocoProdução.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__